module.exports = __webpack_public_path__ + "resources/img/404-big.46bcaa5d.png";